
// Status types
export type BillingStatus = 'current' | 'overdue' | 'inactive';
export type InviteStatus = 'pending' | 'sent' | 'accepted' | 'declined' | 'expired';
export type InvoiceStatus = 'draft' | 'unpaid' | 'partial' | 'paid' | 'overdue' | 'void';
export type PaymentMethod = 'stripe' | 'cash' | 'check' | 'money_order' | 'manual_card';
export type FamilyMemberRole = 'parent' | 'guardian' | 'grandparent' | 'caregiver' | 'other';

// Constants for status
export const BILLING_STATUSES: BillingStatus[] = ['current', 'overdue', 'inactive'];
export const INVITE_STATUSES: InviteStatus[] = ['pending', 'sent', 'accepted', 'declined', 'expired'];
export const INVOICE_STATUSES: InvoiceStatus[] = ['draft', 'unpaid', 'partial', 'paid', 'overdue', 'void'];
export const PAYMENT_METHODS: PaymentMethod[] = ['stripe', 'cash', 'check', 'money_order', 'manual_card'];

// Remove this circular import
// export type { InvoiceStatus } from './financialTypes';
